import { render, staticRenderFns } from "./finance-data-panel-d.vue?vue&type=template&id=1528c681&scoped=true&"
import script from "./finance-data-panel-d.vue?vue&type=script&lang=js&"
export * from "./finance-data-panel-d.vue?vue&type=script&lang=js&"
import style0 from "./finance-data-panel-d.vue?vue&type=style&index=0&id=1528c681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1528c681",
  null
  
)

export default component.exports